import axios from "axios";

export default axios.create({
  baseURL: "https://military-idiot.herokuapp.com",
});
